import React, { useState } from "react";

const About = () => {
  const Data = [
    {
      id: 1,
      title: "Our Mission",
      text: "Supplying quality commodities with reliable delivery to global market and the the best contributing to industry of Agriculture of Myanmar inclusive of the services to Myanmar’s farmers to create better prospects",
    },
    {
      id: 2,
      title: "Our Vision",
      text: "To be an Ultimate player of Myanmar export Industry in Yellow Maize, Rice, Broken Rice, Beans & Pulses",
    },
    {
      id: 3,
      title: "Value",
      text: "• Integrity",
      text1: "• Quality",
      text2: "• Customer Focus and Supplier Reliability",
      text3: "• Innovation",
      text4: "• Sustainability",
      text5: "• Collaboration",
      // text6: "• Adaptability",
      // text7: "• Community Engagement  ",
    },
  ];
  // Set the active tab using state
  const [activeTab, setActiveTab] = useState(0);
  // Function to handle tab selection
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className="my-20 flex lg:flex-row flex-col z-40 justify-between lg:px-16 px-6 gap-20">
      <div className="relative titlefont">
        <div className="relative">
          <h1 className="md:text-4xl  text-3xl font-[600]">
            Sustainable farming
          </h1>
          <span className="absolute -top-[250%] md:-top-[200%] font-outline-2  text-white  -left-[10%] text-[134px] font-[700] textfont opacity-10 -z-10 ">
            ABOUT
          </span>
        </div>
        <div className="mt-10">
          <ul className="flex md:flex-row flex-col ">
            {Data?.map((tab, index) => (
              <li
                key={index}
                className={`text-[18px] font-semibold border-b-4 cursor-pointer hover:border-green-500 px-12 py-4 transition duration-500 ${
                  activeTab === index && " border-green-500"
                }`}
                onClick={() => handleTabClick(index)}
              >
                {tab?.title}
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-8 ">
          <p className="opacity-70 text-[15px] leading-8 ">
            {Data[activeTab].text}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text1}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text2}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text3}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text4}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text5}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text6}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text7}
          </p>
          <p className="opacity-70 text-[15px] mt-2 ">
            {Data[activeTab].text8}
          </p>
        </div>
        <button className="tracking-wider bg-orange-500 text-white px-6 mt-5 shadow-lg py-3">
          Learn More
        </button>
      </div>
      <div>
        <ul className="list-disc flex flex-col gap-3 opacity-75">
          <li>
            Established in November 2022, Green Shine swiftly emerged as a
            transformative force within Myanmar's Agricultural Commodities
            Merchandising Industry. Founded by a visionary team, the company
            recognized the untapped potential of the market and the pressing
            need for a dependable and effective merchandising service.
          </li>
          <li>
            Green Shine meticulously assembled a dedicated team and
            strategically mapped out their operations. Prioritizing the
            establishment of a robust merchandising network and overcame
            numerous challenges, building vital partnerships with merchandising
            platforms along the way.
          </li>

          <li>
            Green Shine swiftly gained recognition for their unwavering
            commitment to excellence. Their relentless focus on reliability and
            efficiency earned the trust and loyalty of customers, suppliers, and
            partners, fueling the company's growth within the competitive
            market.
          </li>
          <li>
            Today, Green Shine stands proudly as a key player in the industry,
            driven by a founding story that highlights the power of seizing
            opportunities and overcoming obstacles. With a solid foundation and
            a culture of innovation, Green Shine is poised to collaborate to
            gain better the future of Agricultural Commodities Merchandising,
            not only in Myanmar but also Globally.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default About;
